"use client"

import { Banner } from '@/app/components/Banner'
import ServiceContent from '@/app/components/ServiceContent'
import { serverHostingImg } from '@/assets/imgs'

import { useTranslations } from 'next-intl'

const ServerHosting = () => {
  const  t  = useTranslations()
  return (
    <>
      <Banner
        subUrl={t('links.services')}
        name={t('links.serverHosting')}
        description={t('serverHosting.bannerDescription')}
        className='bg-serverHosting'
      />
      <ServiceContent
        title={t('links.serverHosting')}
        header={t('serverHosting.header')}
        subContent={t('serverHosting.subTitle')}
        content={t('serverHosting.content')}
        img={serverHostingImg}
      />
    </>
  )
}

export default ServerHosting
